<template>
	<div>
		<v-card
			v-for="leaderboard in Object.keys(leaderboardsData)"
			:key="leaderboard"
			class="pa-2 mt-4 text-xs-center"
			style="cursor: pointer;"
			@click="openSelectedLeaderboard(leaderboard)"
			>{{ leaderboardsData[leaderboard].displayName }}</v-card
		>
		<v-dialog max-width="600px" fullscreen hide-overlay v-model="showDialog"
			><div>
				<div
					class="header"
					:style="{
						backgroundColor: themeInputColor
					}"
				>
					<v-btn
						fab
						flat
						icon
						class="top-left-align pa-0 ma-0 z-index--2"
						@click="showDialog = false"
					>
						<v-icon color="#FFF">arrow_back</v-icon>
					</v-btn>
					{{ selectedLeaderboardData.displayName }}
				</div>
				<v-card min-height="100vh" class="card">
					<div
						v-if="
							(selectedLeaderboardData.rankList || []).length > 0
						"
						style="min-width:50vh"
					>
						<v-layout d-flex justify-space-around pb-4>
							<v-layout
								v-for="(item, index) in getFirstThreeRank"
								:key="index"
								justify-end
								align-center
								column
								:style="[
									{
										order:
											(
												selectedLeaderboardData.rankList ||
												[]
											).length > 2
												? index === 0
													? 15
													: index * 10
												: 1
									}
								]"
								style="flex: 1 !important"
							>
								<div
									class="outerCircle"
									:class="{
										darkBorder: item.userId === userId
									}"
								>
									<v-avatar :size="index === 0 ? '80' : '60'">
										<div
											class="imageCircle"
											:style="[
												{
													background: getHeadOnUserBackgroundColor(
														item.userId
													)
												}
											]"
										>
											{{
												(item.retailerName &&
													item.retailerName
														.charAt(0)
														.toUpperCase()) ||
													"-"
											}}
										</div>
									</v-avatar>
									<div class="smallCircle">
										{{ item.rank }}
									</div>
								</div>
								<div
									class="body-1 ellipsis text-center"
									style="width: 100%"
								>
									{{ item.retailerName }}
								</div>
								<div class="greenText">
									{{ item.value }}
								</div>
							</v-layout>
						</v-layout>
						<div
							v-if="
								(selectedLeaderboardData.rankList || [])
									.length > 0
							"
							class="tableContainer"
						>
							<div class="tableHeader">
								<div style="min-width:200px">Rank</div>
								<div
									style="display:flex;justify-content:space-around;min-width: 600px"
								>
									<div>Value</div>
									<div>
										{{ isPrizeExist ? "Prize" : "" }}
									</div>
									<div>
										{{ isPrizeExist ? "Image" : "" }}
									</div>
								</div>
							</div>
							<v-card v-if="getSelfEntry.length > 0">
								<div class="listEntry">
									<div class="entryRank">
										{{ getSelfEntry[0].rank }}
									</div>
									<div class="entryImage">
										<v-avatar :size="50">
											<div
												class="imageCircle"
												:style="[
													{
														background: getHeadOnUserBackgroundColor(
															getSelfEntry[0]
																.userId
														)
													}
												]"
											>
												{{
													(
														getSelfEntry[0]
															.retailerName || "-"
													).length > 0
														? getSelfEntry[0]
																.retailerName &&
														  getSelfEntry[0].retailerName
																.charAt(0)
																.toUpperCase()
														: "-"
												}}
											</div>
										</v-avatar>
									</div>
									<div>
										<div>
											{{ getSelfEntry[0].retailerName }}
										</div>
									</div>
									<div class="entryInfo">
										<div class="entryValue">
											{{ getSelfEntry[0].value }}
										</div>
										<div class="entryValue">
											{{
												isPrizeExist
													? (
															getSelfEntry[0]
																.prize || {}
													  ).prize || "-"
													: ""
											}}
										</div>
										<div class="entryValue">
											{{
												isPrizeExist
													? (
															getSelfEntry[0]
																.prize || {}
													  ).image || "-"
													: ""
											}}
										</div>
									</div>
								</div>
							</v-card>
							<div>
								<v-card
									v-for="item in selectedLeaderboardData.rankList"
									:key="item.userId"
								>
									<div
										v-if="
											item.userId !== userId &&
												item.userId
										"
										class="listEntry"
										:key="item.userId"
									>
										<div class="entryRank">
											{{ item.rank }}
										</div>
										<div class="entryImage">
											<v-avatar :size="50">
												<div
													class="imageCircle"
													:style="[
														{
															background: getHeadOnUserBackgroundColor(
																item.userId
															)
														}
													]"
												>
													{{
														(
															item.retailerName ||
															"-"
														).length > 0
															? item.retailerName &&
															  item.retailerName
																	.charAt(0)
																	.toUpperCase()
															: "-"
													}}
												</div>
											</v-avatar>
										</div>
										<div>
											{{ item.retailerName }}
										</div>
										<div class="entryInfo">
											<div class="entryValue">
												{{ item.value }}
											</div>
											<div
												class="entryValue"
												v-if="isPrizeExist"
											>
												{{
													(item.prize || {}).prize ||
														"-"
												}}
											</div>
											<div
												class="entryValue"
												v-if="isPrizeExist"
											>
												{{
													(item.prize || {}).image ||
														"-"
												}}
											</div>
										</div>
									</div>
								</v-card>
							</div>
						</div>
					</div>
				</v-card>
			</div>
		</v-dialog>
		<div v-if="isDataLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { THEME_INPUT_COLOUR } from "../constants";
import { FETCH_USER_METRIC_LEADERBOARDS } from "../../store/action-types";
import { getHeadOnUserBackgroundColor } from "../../utils";

export default {
	name: "AllLeaderboards",
	data: () => ({
		leaderboardsData: {},
		isDataLoading: false,
		showDialog: false,
		themeInputColor: THEME_INPUT_COLOUR,
		selectedLeaderboardData: [],
		isPrizeExist: false
	}),
	mounted() {
		// this.fetchUserMetricLeaderboards(this.userId);
	},
	methods: {
		fetchUserMetricLeaderboards(userId) {
			this.isDataLoading = true;
			this.$store
				.dispatch(FETCH_USER_METRIC_LEADERBOARDS.dispatch, {
					userId
				})
				.then(data => {
					this.leaderboardsData = data || {};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		},
		openSelectedLeaderboard(leaderboard) {
			this.selectedLeaderboardData = this.leaderboardsData[leaderboard];
			this.isPrizeExist =
				this.getFirstThreeRank[0].prize &&
				this.getFirstThreeRank[0].prize.prize;
			this.showDialog = true;
		},
		getHeadOnUserBackgroundColor(userId) {
			return getHeadOnUserBackgroundColor(userId);
		}
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		}),
		getSelfEntry() {
			return (
				this.selectedLeaderboardData.rankList.filter(
					user => user.userId === this.userId
				) || []
			);
		},
		getFirstThreeRank() {
			return (
				this.selectedLeaderboardData.rankList.filter(user =>
					[1, 2, 3].includes(user.rank)
				) || []
			)
				.sort((userA, userB) => {
					if (userA.rank < userB.rank) {
						return -1;
					} else if (userA.rank > userB.rank) {
						return 1;
					}
					return 0;
				})
				.splice(0, 3);
		}
	}
};
</script>

<style>
.header {
	color: #fff;
	font-size: 18px;
	line-height: 21px;
	text-align: center;
	letter-spacing: 0.004em;
	padding: 18px 0px;
	z-index: 1;
	width: 100%;
	height: 65px;
}
.card {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
}
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
.imageCircle {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 20px;
}
.outerCircle {
	border-radius: 50%;
	border: 4px solid #e4f1ff;
	position: relative;
}
.outerCircle.darkBorder {
	border: 4px solid #205fb9;
}
.smallCircle {
	position: absolute;
	bottom: 0;
	right: 0;
	width: 20px;
	height: 20px;
	background: linear-gradient(180deg, #44bb70 0%, #0a8dd3 100%);
	border-radius: 50%;
	font-size: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-weight: 600;
}
.greenText {
	color: #44bb70;
	font-size: 16px;
	font-weight: 600;
}
.tableContainer {
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.1);
	max-width: 100vw;
	overflow: scroll;
}
.tableHeader {
	background: #edf0f7;
	display: flex;
	padding: 2px 6px;
	font-size: 12px;
	color: #7b899e;
	min-width: 800px;
}
@media only screen and (max-device-width: 400px) {
	.entryValue {
		font-size: 12px;
		color: #575f6b;
		font-weight: 600;
		min-width: 200px;
		display: flex;
		justify-content: center;
		padding-left: 100px;
	}
}
.listEntry {
	display: flex;
	align-items: center;
	padding: 12px 8px 14px;
	border-bottom: 1px solid #ccc;
	position: relative;
}

.listEntry > div {
	display: flex;
	align-items: center;
}
.entryRank {
	flex: 0 1 calc(10% - 10px);
	justify-content: center;
	margin-right: 10px;
	font-size: 12px;
	color: #575f6b;
}
.entryImage {
	flex: 0 1 calc(40px - 10px);
	height: 30px;
	margin-right: 10px;
}
.entryInfo {
	flex: 0 1 calc(100% - 10% - 40px);
	display: flex;
	align-items: center;
	justify-content: space-around;
}
.entryValue {
	font-size: 12px;
	color: #575f6b;
	font-weight: 600;
	min-width: 200px;
	display: flex;
	justify-content: center;
}
</style>
